export default __webpack_public_path__ + "static/media/chat-icon.72117a37.svg";